import {
  PosEntry,
  ActionList,
  ActivityEntry,
  PosWineRef,
  PosHistoryEntry,
  PosActivityEntry
} from './types';

/** Demo data matching the V91701 mock. Replace with real API calls. */

export const DEMO_POS: PosEntry[] = [
  {
    id: 1,
    name: 'Maaemo',
    type: 'Fine dining',
    city: 'Oslo',
    region: 'Østlandet',
    country: 'Norway',
    status: 'active',
    network: 'on',
    yourRef: 42,
    totalRefs: 380,
    competitors: 11,
    lastChange: '2 days ago',
    evolution: +12,
    phone: '+47 22 17 99 69',
    email: 'wine@maaemo.no',
    website: 'maaemo.no',
    address: 'Schweigaards gate 15B, Oslo',
    primaryContact: 'Esben Holmboe Bang',
    primaryContactRole: 'Head Sommelier',
    wineListSize: 380,
    avgPrice: '€85',
    lastChecked: '2 days ago',
    stability: 'high',
    stage: 'active',
    shelves: 42,
    myRefs: [
      {
        wine: 'Château Margaux',
        vintage: '2018',
        format: '75cl',
        price: '€320',
        status: 'listed'
      },
      {
        wine: 'Pavillon Rouge',
        vintage: '2019',
        format: '75cl',
        price: '€95',
        status: 'listed'
      },
      {
        wine: 'Margaux du Château Margaux',
        vintage: '2020',
        format: '75cl',
        price: '€52',
        status: 'new'
      }
    ],
    competitorRefs: [
      {
        wine: 'Opus One',
        vintage: '2019',
        format: '75cl',
        price: '€380',
        status: 'listed'
      },
      {
        wine: 'Sassicaia',
        vintage: '2018',
        format: '75cl',
        price: '€210',
        status: 'listed'
      },
      {
        wine: 'Penfolds Grange',
        vintage: '2017',
        format: '75cl',
        price: '€450',
        status: 'listed'
      }
    ],
    activity: [
      {
        id: 'act-1',
        icon: 'note',
        title: 'Note added — Follow-up after sommelier meeting',
        when: 'Today, 09:40',
        user: 'Thiago'
      },
      {
        id: 'act-2',
        icon: 'status',
        title: 'Status changed: Prospect → Active',
        when: '12 days ago',
        user: 'system'
      },
      {
        id: 'act-3',
        icon: 'contact',
        title: 'Last contact attempt (confirmed)',
        when: '3 weeks ago',
        user: 'Thiago'
      }
    ],
    history: [
      {
        date: '2026-05-23',
        method: 'online',
        clientStatus: 'active',
        clientRefs: 42,
        totalRefs: 380,
        notes: 'Stable — 3 new listings'
      },
      {
        date: '2026-04-15',
        method: 'online',
        clientStatus: 'active',
        clientRefs: 39,
        totalRefs: 375,
        notes: '+3 refs from spring allocation'
      },
      {
        date: '2025-09-12',
        method: 'online',
        clientStatus: 'active',
        clientRefs: 36,
        totalRefs: 360,
        notes: 'First listing detected — online scan'
      }
    ],
    myNotes: '',
    actionListIds: []
  },
  {
    id: 2,
    name: 'Vinmonopolet Bjørvika',
    type: 'Retailer (Monopoly)',
    city: 'Oslo',
    region: 'Østlandet',
    country: 'Norway',
    status: 'active',
    network: 'off',
    yourRef: 89,
    totalRefs: 1240,
    competitors: 0,
    lastChange: '5 hours ago',
    evolution: +4,
    phone: '+47 22 01 50 00',
    email: 'kundesenter@vinmonopolet.no',
    website: 'vinmonopolet.no',
    address: 'Dronning Eufemias gate 16, Oslo',
    primaryContact: 'Kristin Haugen',
    primaryContactRole: 'Category Manager',
    wineListSize: 1240,
    avgPrice: '€28',
    lastChecked: '5 hours ago',
    stability: 'high',
    stage: 'active',
    shelves: 89,
    myRefs: [
      {
        wine: 'Château Margaux',
        vintage: '2018',
        format: '75cl',
        price: '€320',
        status: 'listed'
      },
      {
        wine: 'Pavillon Rouge',
        vintage: '2019',
        format: '75cl',
        price: '€95',
        status: 'listed'
      },
      {
        wine: 'Margaux du Château Margaux',
        vintage: '2020',
        format: '75cl',
        price: '€52',
        status: 'listed'
      },
      {
        wine: 'Château Margaux',
        vintage: '2016',
        format: '150cl',
        price: '€680',
        status: 'listed'
      }
    ],
    competitorRefs: [],
    activity: [
      {
        id: 'act-v1',
        icon: 'note',
        title: 'Allocation confirmed — Q2 2026 spring delivery',
        when: '5 hours ago',
        user: 'Thiago'
      },
      {
        id: 'act-v2',
        icon: 'email',
        title: 'Email sent to category manager — vintage change notification',
        when: '1 week ago',
        user: 'Thiago'
      }
    ],
    history: [
      {
        date: '2026-05-25',
        method: 'online',
        clientStatus: 'active',
        clientRefs: 89,
        totalRefs: 1240,
        notes: '+4 refs from spring allocation'
      },
      {
        date: '2026-03-10',
        method: 'online',
        clientStatus: 'active',
        clientRefs: 85,
        totalRefs: 1195,
        notes: 'Stable'
      },
      {
        date: '2025-11-01',
        method: 'import',
        clientStatus: 'active',
        clientRefs: 82,
        totalRefs: 1150,
        notes: 'Autumn assortment update'
      }
    ],
    myNotes: 'Key monopoly account. Always check allocation windows.',
    actionListIds: []
  },
  {
    id: 3,
    name: 'Sentralen Restaurant',
    type: 'Mid-scale dining',
    city: 'Oslo',
    region: 'Østlandet',
    country: 'Norway',
    status: 'towin',
    network: 'on',
    yourRef: 8,
    totalRefs: 95,
    competitors: 14,
    lastChange: '1 week ago',
    evolution: -2,
    phone: '+47 22 33 44 22',
    email: 'booking@sentralen.no',
    website: 'sentralen.no',
    address: 'Øvre Slottsgate 3, Oslo',
    primaryContact: 'Anders Vestby',
    primaryContactRole: 'Sommelier',
    wineListSize: 95,
    avgPrice: '€55',
    lastChecked: '1 week ago',
    stability: 'medium',
    stage: 'towin',
    shelves: 8,
    myRefs: [
      {
        wine: 'Pavillon Rouge',
        vintage: '2019',
        format: '75cl',
        price: '€95',
        status: 'listed'
      },
      {
        wine: 'Margaux du Château Margaux',
        vintage: '2020',
        format: '75cl',
        price: '€52',
        status: 'listed'
      }
    ],
    competitorRefs: [
      {
        wine: 'Cloudy Bay Sauvignon Blanc',
        vintage: '2023',
        format: '75cl',
        price: '€32',
        status: 'listed'
      },
      {
        wine: 'Antinori Tignanello',
        vintage: '2019',
        format: '75cl',
        price: '€120',
        status: 'listed'
      },
      {
        wine: 'Domaine Drouhin Oregon Pinot Noir',
        vintage: '2020',
        format: '75cl',
        price: '€58',
        status: 'listed'
      }
    ],
    activity: [
      {
        id: 'act-sr1',
        icon: 'contact',
        title: 'Contact attempt — left message with sommelier',
        when: '1 week ago',
        user: 'Thiago'
      },
      {
        id: 'act-sr2',
        icon: 'note',
        title: 'Noted: prefer Burgundy-style wines, open to tasting',
        when: '2 weeks ago',
        user: 'Thiago'
      }
    ],
    history: [
      {
        date: '2026-05-18',
        method: 'online',
        clientStatus: 'towin',
        clientRefs: 8,
        totalRefs: 95,
        notes: '-2 delisted (vintage change)'
      },
      {
        date: '2026-02-20',
        method: 'online',
        clientStatus: 'towin',
        clientRefs: 10,
        totalRefs: 92,
        notes: 'First scan'
      }
    ],
    myNotes: 'Sommelier interested in Bordeaux verticals. Follow up in June.',
    actionListIds: []
  },
  {
    id: 4,
    name: 'Lofthus Samvirkelag',
    type: 'Specialty retailer',
    city: 'Lofthus',
    region: 'Vestland',
    country: 'Norway',
    status: 'active',
    network: 'off',
    yourRef: 21,
    totalRefs: 140,
    competitors: 4,
    lastChange: '3 days ago',
    evolution: +6,
    phone: '+47 53 66 11 00',
    email: 'post@lofthus-samvirkelag.no',
    website: 'lofthus-samvirkelag.no',
    address: 'Lofthus, Hardanger, 5781',
    primaryContact: 'Bjørn Eirik Lund',
    primaryContactRole: 'Store Manager',
    wineListSize: 140,
    avgPrice: '€35',
    lastChecked: '3 days ago',
    stability: 'high',
    stage: 'active',
    shelves: 21,
    myRefs: [
      {
        wine: 'Château Margaux',
        vintage: '2016',
        format: '75cl',
        price: '€285',
        status: 'listed'
      },
      {
        wine: 'Pavillon Rouge',
        vintage: '2018',
        format: '75cl',
        price: '€88',
        status: 'listed'
      },
      {
        wine: 'Pavillon Rouge',
        vintage: '2019',
        format: '75cl',
        price: '€95',
        status: 'new'
      }
    ],
    competitorRefs: [
      {
        wine: 'Tignanello',
        vintage: '2019',
        format: '75cl',
        price: '€115',
        status: 'listed'
      },
      {
        wine: 'Cloudy Bay',
        vintage: '2023',
        format: '75cl',
        price: '€28',
        status: 'listed'
      }
    ],
    activity: [],
    history: [
      {
        date: '2026-05-22',
        method: 'online',
        clientStatus: 'active',
        clientRefs: 21,
        totalRefs: 140,
        notes: '+6 refs from spring delivery'
      },
      {
        date: '2026-02-14',
        method: 'manual',
        clientStatus: 'active',
        clientRefs: 15,
        totalRefs: 128,
        notes: 'Visit — updated shelf count'
      }
    ],
    myNotes: '',
    actionListIds: []
  },
  {
    id: 5,
    name: 'Bjørvika Wine Bar',
    type: 'Wine bar',
    city: 'Oslo',
    region: 'Østlandet',
    country: 'Norway',
    status: 'prospect',
    network: 'on',
    yourRef: 3,
    totalRefs: 210,
    competitors: 9,
    lastChange: '1 day ago',
    evolution: +18,
    phone: '+47 21 09 87 00',
    email: 'hello@bjorvika-wine.no',
    website: 'bjorvika-wine.no',
    address: 'Operagata 7, Oslo',
    primaryContact: 'Hanne Solberg',
    primaryContactRole: 'Wine Director',
    wineListSize: 210,
    avgPrice: '€68',
    lastChecked: '1 day ago',
    stability: 'medium',
    stage: 'prospect',
    shelves: 3,
    myRefs: [
      {
        wine: 'Margaux du Château Margaux',
        vintage: '2020',
        format: '75cl',
        price: '€52',
        status: 'new'
      }
    ],
    competitorRefs: [
      {
        wine: 'Château Latour',
        vintage: '2008',
        format: 'bottle',
        price: '€950',
        status: 'listed'
      },
      {
        wine: 'Château Ausone',
        vintage: '2009',
        format: 'bottle',
        price: '€1310',
        status: 'listed'
      },
      {
        wine: 'Château Cheval Blanc',
        vintage: '2008',
        format: 'bottle',
        price: '€980',
        status: 'listed'
      },
      {
        wine: 'Château Cheval Blanc',
        vintage: '2017',
        format: 'magnum',
        price: '€1210',
        status: 'listed'
      },
      {
        wine: 'Château Lafite Rothschild',
        vintage: '2022',
        format: 'bottle',
        price: '€890',
        status: 'listed'
      },
      {
        wine: 'La Mission Haut-Brion',
        vintage: '2018',
        format: 'bottle',
        price: '€1120',
        status: 'listed'
      },
      {
        wine: 'La Mission Haut-Brion',
        vintage: '2011',
        format: 'bottle',
        price: '€890',
        status: 'listed'
      },
      {
        wine: 'Château Haut-Brion',
        vintage: '2020',
        format: 'bottle',
        price: '€1530',
        status: 'listed'
      },
      {
        wine: 'Château Haut-Brion',
        vintage: '2016',
        format: 'bottle',
        price: '€770',
        status: 'listed'
      }
    ],
    activity: [
      {
        id: 'act-bw1',
        icon: 'note',
        title: 'New POS discovered — strong Bordeaux focus, competitor-heavy',
        when: '1 day ago',
        user: 'Thiago'
      }
    ],
    history: [
      {
        date: '2026-05-24',
        method: 'online',
        clientStatus: 'prospect',
        clientRefs: 3,
        totalRefs: 210,
        notes: 'First scan — 14 competitor wines detected'
      }
    ],
    myNotes:
      'Very interesting prospect. Heavy Bordeaux 1er cru list. Wine director open to meeting.',
    actionListIds: []
  },
  {
    id: 6,
    name: 'Statholdergaarden',
    type: 'Fine dining',
    city: 'Oslo',
    region: 'Østlandet',
    country: 'Norway',
    status: 'lost',
    network: 'on',
    yourRef: 0,
    totalRefs: 295,
    competitors: 16,
    lastChange: '2 weeks ago',
    evolution: -12,
    phone: '+47 22 41 88 00',
    email: 'info@statholdergaarden.no',
    website: 'statholdergaarden.no',
    address: 'Rådhusgata 11, Oslo',
    primaryContact: 'Bent Stiansen',
    primaryContactRole: 'Owner / Chef',
    wineListSize: 295,
    avgPrice: '€72',
    lastChecked: '2 weeks ago',
    stability: 'low',
    stage: 'lost',
    shelves: 0,
    myRefs: [],
    competitorRefs: [
      {
        wine: 'Domaine de la Romanée-Conti',
        vintage: '2017',
        format: '75cl',
        price: '€1200',
        status: 'listed'
      },
      {
        wine: 'Opus One',
        vintage: '2019',
        format: '75cl',
        price: '€380',
        status: 'listed'
      }
    ],
    activity: [
      {
        id: 'act-s1',
        icon: 'note',
        title: 'Risk note shared with team — Statholdergaarden delisting',
        when: 'Today, 09:40',
        user: 'Élise'
      },
      {
        id: 'act-s2',
        icon: 'status',
        title: 'Status changed: Active → Lost',
        when: '12 days ago',
        user: 'system'
      },
      {
        id: 'act-s3',
        icon: 'contact',
        title: 'Last contact attempt (no answer)',
        when: '3 weeks ago',
        user: 'Élise'
      }
    ],
    history: [
      {
        date: '2022-09-12',
        method: 'online',
        clientStatus: 'active',
        clientRefs: 0,
        totalRefs: 456,
        notes: 'First listing detected — online scan'
      }
    ],
    myNotes: '',
    actionListIds: ['AL-001']
  },
  {
    id: 7,
    name: 'Bergen Bistro & Vin',
    type: 'Bistro',
    city: 'Bergen',
    region: 'Vestland',
    country: 'Norway',
    status: 'active',
    network: 'on',
    yourRef: 14,
    totalRefs: 88,
    competitors: 8,
    lastChange: '4 days ago',
    evolution: +3,
    phone: '+47 55 30 40 12',
    email: 'vin@bergenbistro.no',
    website: 'bergenbistro.no',
    address: 'Vågsgaten 12, Bergen',
    primaryContact: 'Lars Kristiansen',
    primaryContactRole: 'Owner / Sommelier',
    wineListSize: 88,
    avgPrice: '€48',
    lastChecked: '4 days ago',
    stability: 'high',
    stage: 'active',
    shelves: 14,
    myRefs: [
      {
        wine: 'Château Margaux',
        vintage: '2018',
        format: '75cl',
        price: '€320',
        status: 'listed'
      },
      {
        wine: 'Pavillon Rouge',
        vintage: '2019',
        format: '75cl',
        price: '€95',
        status: 'listed'
      }
    ],
    competitorRefs: [
      {
        wine: 'Barolo Monfortino Riserva',
        vintage: '2016',
        format: '75cl',
        price: '€450',
        status: 'listed'
      },
      {
        wine: 'Domaine Leflaive Puligny-Montrachet',
        vintage: '2020',
        format: '75cl',
        price: '€180',
        status: 'listed'
      }
    ],
    activity: [
      {
        id: 'act-bb1',
        icon: 'email',
        title: 'Tasting invitation sent — spring portfolio',
        when: '4 days ago',
        user: 'Lars'
      },
      {
        id: 'act-bb2',
        icon: 'contact',
        title: 'Visit confirmed — April 18 tasting',
        when: '1 week ago',
        user: 'Lars'
      }
    ],
    history: [
      {
        date: '2026-05-21',
        method: 'online',
        clientStatus: 'active',
        clientRefs: 14,
        totalRefs: 88,
        notes: '+3 natural wine listings'
      },
      {
        date: '2026-01-10',
        method: 'manual',
        clientStatus: 'active',
        clientRefs: 11,
        totalRefs: 82,
        notes: 'Visit — shelf audit'
      }
    ],
    myNotes: '',
    actionListIds: ['AL-002']
  },
  {
    id: 8,
    name: 'Trondheim Vinkjeller',
    type: 'Wine cellar / Restaurant',
    city: 'Trondheim',
    region: 'Trøndelag',
    country: 'Norway',
    status: 'towin',
    network: 'on',
    yourRef: 5,
    totalRefs: 165,
    competitors: 12,
    lastChange: '1 week ago',
    evolution: 0,
    phone: '+47 73 52 80 00',
    email: 'info@trondheimvinkjeller.no',
    website: 'trondheimvinkjeller.no',
    address: 'Nordre gate 28, Trondheim',
    primaryContact: 'Ole Morten Dahl',
    primaryContactRole: 'Head Sommelier',
    wineListSize: 165,
    avgPrice: '€62',
    lastChecked: '1 week ago',
    stability: 'medium',
    stage: 'towin',
    shelves: 5,
    myRefs: [
      {
        wine: 'Pavillon Rouge',
        vintage: '2019',
        format: '75cl',
        price: '€95',
        status: 'listed'
      }
    ],
    competitorRefs: [
      {
        wine: 'Penfolds Grange',
        vintage: '2018',
        format: '75cl',
        price: '€480',
        status: 'listed'
      },
      {
        wine: 'Vega Sicilia Único',
        vintage: '2012',
        format: '75cl',
        price: '€350',
        status: 'listed'
      },
      {
        wine: 'Ridge Monte Bello',
        vintage: '2019',
        format: '75cl',
        price: '€220',
        status: 'listed'
      }
    ],
    activity: [
      {
        id: 'act-tv1',
        icon: 'contact',
        title: 'Handed off to Lars (Mid-Norway)',
        when: '1 week ago',
        user: 'Thiago'
      }
    ],
    history: [
      {
        date: '2026-05-18',
        method: 'online',
        clientStatus: 'towin',
        clientRefs: 5,
        totalRefs: 165,
        notes: 'Stable — no changes'
      }
    ],
    myNotes:
      'Strong cellar with deep vintage focus. Potential for grand cru placement.',
    actionListIds: ['AL-003']
  }
];

export const DEMO_ACTION_LISTS: ActionList[] = [
  {
    id: 'AL-001',
    name: 'Oslo lost-POS recovery — Q1 2026',
    createdAt: '2026-02-14',
    createdBy: 'Thiago',
    sentTo: 'Vinforum AS',
    sentToType: 'distributor',
    privacy: 'private',
    isMine: true,
    action: 'Re-engagement campaign',
    notes:
      'Targeting 8 recently delisted POS within the 90-day recovery window.',
    pos: [
      {
        id: 6,
        name: 'Statholdergaarden',
        city: 'Oslo',
        initialStatus: 'lost',
        currentStatus: 'towin'
      },
      {
        id: 101,
        name: 'Den Røde Mølle',
        city: 'Oslo',
        initialStatus: 'lost',
        currentStatus: 'active'
      },
      {
        id: 102,
        name: 'Engebret Café',
        city: 'Oslo',
        initialStatus: 'lost',
        currentStatus: 'active'
      },
      {
        id: 9,
        name: 'Theatercaféen',
        city: 'Oslo',
        initialStatus: 'lost',
        currentStatus: 'lost'
      }
    ]
  },
  {
    id: 'AL-002',
    name: 'Bergen tasting circle · spring invites',
    createdAt: '2026-03-22',
    createdBy: 'Lars',
    sentTo: 'Bergen Vinklubb',
    sentToType: 'sales-team',
    privacy: 'shared',
    isMine: true,
    action: 'Tasting invitation',
    notes:
      'Invited the Bergen sommelier circle to the April 18 spring portfolio tasting.',
    pos: [
      {
        id: 7,
        name: 'Bergen Bistro & Vin',
        city: 'Bergen',
        initialStatus: 'active',
        currentStatus: 'active'
      },
      {
        id: 12,
        name: 'Lysverket',
        city: 'Bergen',
        initialStatus: 'towin',
        currentStatus: 'active'
      },
      {
        id: 202,
        name: 'Bare Vestland',
        city: 'Bergen',
        initialStatus: 'prospect',
        currentStatus: 'towin'
      }
    ]
  },
  {
    id: 'AL-003',
    name: 'Trondheim cold prospects — handoff',
    createdAt: '2026-04-08',
    createdBy: 'Thiago',
    sentTo: 'Lars (Mid-Norway)',
    sentToType: 'sales-team',
    privacy: 'private',
    isMine: true,
    action: 'Distributor handoff',
    notes: 'Three cold prospects surfaced via Q1 survey. Reassigning to Lars.',
    pos: [
      {
        id: 8,
        name: 'Trondheim Vinkjeller',
        city: 'Trondheim',
        initialStatus: 'towin',
        currentStatus: 'active'
      },
      {
        id: 14,
        name: 'Folk og Fe',
        city: 'Trondheim',
        initialStatus: 'prospect',
        currentStatus: 'prospect'
      },
      {
        id: 15,
        name: 'To Rom og Kjøkken',
        city: 'Trondheim',
        initialStatus: 'prospect',
        currentStatus: 'towin'
      }
    ]
  }
];

export const DEMO_ACTIVITY: ActivityEntry[] = [
  {
    id: 'a1',
    user: 'Thiago',
    userInitials: 'TR',
    kind: 'create',
    action: 'created action list',
    target: 'Oslo lost-POS recovery',
    detail: 'Targeting 8 POS',
    when: '2 hours ago',
    privacy: 'shared',
    sentTo: 'Lars',
    posCount: 8
  },
  {
    id: 'a2',
    user: 'Lars',
    userInitials: 'LK',
    kind: 'email',
    action: 'emailed 3 POS —',
    target: 'Spring portfolio tasting',
    detail: 'Email sent',
    when: '1 day ago',
    recipientCount: 3,
    recipientList: 'Bergen Bistro & Vin, Lysverket, Colonialen'
  },
  {
    id: 'a3',
    user: 'Thiago',
    userInitials: 'TR',
    kind: 'note',
    action: 'added a private note on',
    target: 'Maaemo',
    detail: 'Follow-up after meeting with sommelier',
    when: '2 days ago'
  },
  {
    id: 'a4',
    user: 'Lars',
    userInitials: 'LK',
    kind: 'status',
    action: 'changed status of',
    target: 'Lysverket',
    detail: 'To Win → Active',
    when: '3 days ago'
  },
  {
    id: 'a5',
    user: 'Sofia',
    userInitials: 'SF',
    kind: 'share',
    action: 'shared',
    target: 'Oslo lost-POS recovery — Q1 2026',
    detail: '',
    when: '5 days ago',
    with_: 'Sales team'
  },
  {
    id: 'a6',
    user: 'Joaquin',
    userInitials: 'JQ',
    kind: 'edit',
    action: 'added 3 POS to',
    target: 'Bergen tasting circle · spring invites',
    detail: '+3 POS added',
    when: '1 week ago'
  },
  {
    id: 'a7',
    user: 'Thiago',
    userInitials: 'TR',
    kind: 'visit',
    action: 'logged a tasting visit at',
    target: 'Statholdergaarden',
    detail: '',
    when: '10 days ago'
  },
  {
    id: 'a8',
    user: 'Élise',
    userInitials: 'ÉL',
    kind: 'status',
    action: 'changed status of',
    target: 'Trondheim Vinkjeller',
    detail: 'Prospect → To Win',
    when: '2 weeks ago'
  }
];
